import React, { ReactNode, useEffect, useState } from 'react'

import { NewPlanYearSelector } from 'adminDashboard/benefitDetails/common/NewPlanYearSelector'
import { Skeleton } from 'antd'
import moment from 'moment'

import benefitPlanPeriods, { PlanPeriodDto } from 'core/application/adminDashboard/benefitDetails/benefitPlanPeriods'
import { BenefitInfo, getBenefitInfo } from 'core/application/adminDashboard/benefitInfo'
import { BenefitDesignStatus } from 'core/domain/benefit/benefitDesignStatus'

import { queryRequest } from 'common/RequestUtils'

import ReimbursementRequests from '../../../common/reimbursementRequests'
import TransactionHistory from '../../../common/transactionHistory'
import BenefitSummary from './benefitSummary'

const getPlanPeriodsCombo = (
  planPeriods: PlanPeriodDto[] | undefined,
  selected: string | undefined,
  setActivePlanPeriod: (planPeriod: string) => void,
): ReactNode => {
  return [
    <div key="summary" className="benefit_period">
      {planPeriods ? (
        <NewPlanYearSelector planPeriods={planPeriods} selected={selected} setActivePlanPeriod={setActivePlanPeriod} />
      ) : null}
    </div>,
  ]
}

const Summary: React.FC = () => {
  const [benefits, setBenefits] = useState<BenefitInfo>()
  const [activePlanPeriod, setActivePlanPeriod] = useState<string | undefined>(undefined)

  const [planPeriods, setPlanPeriods] = useState<PlanPeriodDto[] | undefined>(undefined)

  const getPlanPeriods = async () => {
    const data = await queryRequest(() => benefitPlanPeriods())
    var active = data.filter(
      (x: PlanPeriodDto) =>
        x.benefitDesignStatus == BenefitDesignStatus.Signed && (moment(x.startDate) < moment() || x.active),
    )
    setPlanPeriods(data)
    setActivePlanPeriod(active[0] ? active[0].id : data[0].id)
  }

  useEffect(() => {
    getPlanPeriods()
  }, [])

  useEffect(() => {
    activePlanPeriod && getBenefitsData()
  }, [activePlanPeriod])

  const getBenefitsData = async () => {
    const benefit = await queryRequest(() => getBenefitInfo(activePlanPeriod))
    setBenefits(benefit)
  }

  return (
    <div data-testid={'ee-group-hra-dashboard'}>
      <BenefitSummary />
      <div className="pt-16">
        <Skeleton active loading={benefits === undefined}>
          {getPlanPeriodsCombo(planPeriods, activePlanPeriod, setActivePlanPeriod)}
        </Skeleton>
      </div>
      <div className="pt-16">
        <Skeleton active loading={benefits === undefined}>
          {benefits ? <ReimbursementRequests planPeriodId={activePlanPeriod} /> : null}
        </Skeleton>
      </div>
      <div className="pt-16">
        <Skeleton active loading={benefits === undefined}>
          {benefits ? <TransactionHistory planPeriodId={activePlanPeriod} /> : null}
        </Skeleton>
      </div>
    </div>
  )
}

export default Summary
